import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import TermsDisclaimer from 'apps/auth/components/history/send/TermsDisclaimer';
import { apiFetchData } from 'apps/auth/helpers/api';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const MyIdLuluKycPopup = ({ confirmUrl, toggleSpinner, toggleModal, updateExtraByName, content, redirectUrl, popupRef, extraName }) => {
    const { reviewTermsButton, acceptButton, termsUzTitle, acceptContinueButton } = usePageMessages();
    const { linkToMyIdTerms } = useExtra();

    return (
        <SimplePopup popupRef={popupRef} text={<DangerouslyHtml dangerouslyHtml={termsUzTitle} />}>
            <PopupButton
                iconName="info-rounded"
                text={reviewTermsButton}
                href={linkToMyIdTerms ?? '#'}
                target="_blank"
                onClick={(e) => {
                    if (linkToMyIdTerms) {
                        return;
                    }
                    e.preventDefault();
                    popupRef.current?.close();
                    toggleModal(
                        true,
                        <TermsDisclaimer
                            canCloseModal
                            closeModalHandler={() => updateExtraByName(extraName, false)}
                            continueButton={acceptButton}
                            confirmationPath={confirmUrl}
                            content={content}
                        />,
                    );
                }}
            />
            <PopupButton
                iconName="arrow-forward"
                text={acceptContinueButton}
                onClick={() => {
                    popupRef.current?.close();
                    toggleSpinner(true);
                    apiFetchData(confirmUrl).finally(() => {
                        window.location.replace(redirectUrl);
                    });
                }}
            />
        </SimplePopup>
    );
};
MyIdLuluKycPopup.propTypes = {
    confirmUrl: PropTypes.string,
    toggleSpinner: PropTypes.func,
    toggleModal: PropTypes.func,
    updateExtraByName: PropTypes.func,
    content: PropTypes.string,
    redirectUrl: PropTypes.string,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    extraName: PropTypes.string,
};

export default connect(null, { toggleSpinner, toggleModal, updateExtraByName })(MyIdLuluKycPopup);
